import React from 'react';
import cx from 'classnames';

import VariableLayerItem from '../VariableLayerItem';

import styles from './VariableLayerItemList.module.scss';
import usePresenter from './VariableLayerItemList.presenter';
import getProps from './VariableLayerItemList.props';
import { VariableLayerItemListCombinedProps } from './types';

const VariableLayerItemList: React.FC<VariableLayerItemListCombinedProps> = (props) => {
  const {
    className,
    classes,
    variableLayerItems,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.variableLayerItemList;

  const variableLayerItemViews = variableLayerItems?.map((variableLayerItem, index) => (
    <VariableLayerItem
      key={index}
      className={cx(styles.variableLayerItem, classes?.variableLayerItem)}
      {...internalProps.variableLayerItem}
      {...variableLayerItem} />
  )) || [];

  return (
    <div className={cx(currentStyle, className)}>
      {variableLayerItemViews}
    </div>
  );
};

export default VariableLayerItemList;
